export const getDayData = (none) => {
    let result = [];
    for (let i = 1; i <= 31; i++) {
        result.push({
            label: i.toString(),
            value: i.toString()
        });
    }
    return result;
};
export const getMonthData = (none) => {
    let result = [];
    for (let i = 1; i <= 12; i++) {
        result.push({
            label: i.toString(),
            value: i.toString()
        });
    }
    return result;
};
export const getYearData = (none, minAge) => {
    let result = [];
    for (let i = (new Date()).getFullYear() - minAge; i >= 1920; i = i - 1) {
        result.push({
            label: i.toString(),
            value: i.toString()
        });
    }
    return result;
};
//# sourceMappingURL=getDateData.js.map